/**
 * Media Mapping — slug-to-asset-name lookup for blog post hero images.
 *
 * Trimmed to the single mapping the marketing site actually consumes
 * (blog post slug → media asset name in mediadb). Use-case / category /
 * background mappings carried over from the deprecated app surface had
 * no consumers in this repo and were dropped during the post-lift orphan
 * cleanup. Add entries here when a new blog post lands.
 */

const BLOG_IMAGES: Record<string, string> = {
  'ai-uneven-impact': 'ai_uneven_impact_dark_blog',
};

export function getBlogImageName(slug: string): string | null {
  return BLOG_IMAGES[slug] ?? null;
}
